import { PermissionFields, PermissionLevelEnum, PermissionSection } from "@models/PermissionSection";
import { iReportProPublication, ReportProPublication } from "@models/ReportProPublication";
import { components } from "@apiSchema";
import { FoodProfileRecommendedCharts, iFoodProfileRecommendedCharts } from "@models/FoodProfileRecommendedCharts";

export interface IFoodProfileDocuments {
    reports: PermissionFields & {
        data: {
            totalCount: number;
            reports: iReportProPublication[];
        }
    };
    macAndInstantChart: iFoodProfileRecommendedCharts;
}

type ApiModel = components["schemas"]["FoodProfileDocumentsDataViewModel"];

interface IData {
    apiModel?: ApiModel;
    query?: string;
}

export class FoodProfileDocuments implements IFoodProfileDocuments {
    static readonly defaultData: IFoodProfileDocuments = {
        reports: {
            permissionLevel: PermissionLevelEnum.Full,
            hasData: true,
            data: {
                totalCount: 0,
                reports: [],
            }
        },
        macAndInstantChart: new FoodProfileRecommendedCharts(),
    }

    static readonly fakeData: IFoodProfileDocuments = {
        reports: {
            permissionLevel: PermissionLevelEnum.Full,
            hasData: true,
            data: {
                totalCount: 0,
                reports: [],
            }
        },
        macAndInstantChart: {
            hasData: true,
            permissionLevel: PermissionLevelEnum.None,
            data: FoodProfileRecommendedCharts.fakeData,
        },
    }

    reports = FoodProfileDocuments.defaultData.reports;
    macAndInstantChart = FoodProfileDocuments.defaultData.macAndInstantChart;

    constructor(data?: IData) {
        if (data && data.apiModel) {
            this.mapFromApi(data.apiModel, data.query);
        }
    }

    private setData(model: IFoodProfileDocuments) {
        Object.assign(this, model);
    }

    private mapFromApi(data: ApiModel, query?: string): void {
        const {
            document,
        } = data;

        const reportsPermissionLevel = PermissionSection.getPermissionLevel(document?.permissionLevel);

        this.setData({
            reports: {
                permissionLevel: reportsPermissionLevel,
                hasData: document?.hasData ?? false,
                data: reportsPermissionLevel === PermissionLevelEnum.None
                    ? FoodProfileDocuments.defaultData.reports.data
                    : {
                        totalCount: document?.data?.totalCount ?? FoodProfileDocuments.defaultData.reports.data.totalCount,
                        reports: (document?.data?.items ?? []).map(
                            item => new ReportProPublication({ apiModel: item })
                        ),
                    }
            },
            macAndInstantChart: new FoodProfileRecommendedCharts({
                apiModel: data?.macAndInstantChart,
                searchQuery: query ?? '',
            }),
        })
    }
}